<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_ComeOn_Field_Host')"
        prop="params.url"
        :hint="$t('Integrations_ComeOn_Field_Host_Hint')"
      >
        <el-input v-model="model.params.url" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_ComeOn_Field_Port')"
        prop="params.port"
        :hint="$t('Integrations_ComeOn_Field_Port_Hint')"
      >
        <el-input v-model.number="model.params.port" />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'ComeOnSettings',
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  components: {
    FormSection,
    RestFormItem
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          url: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          port: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              type: 'integer',
              message: this.$t('RestForm_ValueShouldBeANumber')
            }
          ]
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/comeon/ComeOnSettings.vue